// extracted by mini-css-extract-plugin
export default {"content":"trk7cxwESW","description":"Xy806NcQxI","video":"RVUcsslruQ"};